function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { UnresolvableReferenceError } from '../UnresolvableReferenceError';
export class DenormalizedManager {
    resolve(link) {
        const map = link.link_type === 'Asset' ? this.assetsById : this.entriesById;
        const denormalized = map.get(link.primary_key);
        if (denormalized) {
            return denormalized;
        } else {
            throw new UnresolvableReferenceError(link);
        }
    }
    add({ entries, assets }) {
        for (const [id, entry] of entries.entries()){
            this.entriesById.set(id, entry);
        }
        for (const [id, asset] of assets.entries()){
            this.assetsById.set(id, asset);
        }
    }
    constructor(){
        _define_property(this, "entriesById", new Map());
        _define_property(this, "assetsById", new Map());
    }
}

//# sourceMappingURL=DenormalizedManager.js.map